export const SegmentIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.593 11.055a1.923 1.923 0 011.923-1.924V6.797a.833.833 0 00-.833-.833h-3.155a1.923 1.923 0 10-3.133 0H6.24a.833.833 0 00-.833.833V9.13a1.923 1.923 0 00-.187 3.839.205.205 0 01.187.203v3.069a.833.833 0 00.833.833h9.443a.833.833 0 00.833-.833v-3.059a.216.216 0 00-.195-.214 1.924 1.924 0 01-1.728-1.913v0z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
};
